import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const IntegrationsView = React.lazy(() => import("./Integrations.view"));

const IntegrationsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <IntegrationsView />
  </React.Suspense>
);

export default () => <IntegrationsLoadable />;
